(function () {
  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (!items.length) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var el = entry.target;
          var delay = el.getAttribute('data-reveal-delay') || 0;

          setTimeout(function () {
            el.classList.add('is-revealed');
          }, parseInt(delay, 10));

          observer.unobserve(el);
        });
      },
      { threshold: 0.15 }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();